import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

export const MasteryStars = ({ level = 0, size = 4 }) => (
  <div className="flex items-center gap-0.5" data-testid="mastery-stars" aria-label={`Maîtrise ${level} sur 5`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        className={cn(
          `w-${size} h-${size}`,
          i <= level ? "fill-accent text-accent" : "fill-slate-100 text-slate-200",
        )}
      />
    ))}
  </div>
);

const LEVEL_LABELS = ["Nouveau", "Découvert", "Fragile", "Moyen", "Bon", "Maîtrisé"];
export const levelLabel = (l) => LEVEL_LABELS[Math.max(0, Math.min(5, l))];

export const VerseCard = ({ ayah, surahName, translation = true, className }) => (
  <div className={cn("bg-white p-6 sm:p-8 rounded-3xl shadow-[0_4px_20px_rgba(0,0,0,0.04)] border border-slate-100", className)} data-testid="verse-card">
    <div className="flex items-center justify-between mb-4">
      <span className="text-xs font-bold uppercase tracking-wider text-slate-400">{surahName}</span>
      <span className="w-8 h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center text-sm font-extrabold">
        {ayah.number_in_surah}
      </span>
    </div>
    <p className="font-arabic text-3xl sm:text-4xl leading-[2.2] text-slate-900 text-right mb-4" data-testid="verse-arabic">
      {ayah.text_ar}
    </p>
    {translation && (
      <p className="text-slate-600 leading-relaxed border-t border-slate-100 pt-4" data-testid="verse-translation">
        {ayah.translation_fr}
      </p>
    )}
  </div>
);
